<template>
    <div class="">
        <div class="load" v-if="spinning == true">
            <a-spin :spinning="spinning" tip="Loading..."></a-spin>
        </div>


        <div id="components-form-demo-advanced-search">
            <a-form
                    class="ant-advanced-search-form"
                    :form="form"
                    @submit="handleSearch"
            >
                <a-row :gutter="24">

<!--                    <a-col :span="6">-->
<!--                        <a-form-item label="所属地区">-->
<!--                            <a-cascader :options="optionAreas"-->
<!--                                        :showSearch="showSearch"-->
<!--                                        @change="areaChange"-->
<!--                                        placeholder="请选择"-->
<!--                                        expandTrigger="hover"/>-->
<!--                        </a-form-item>-->
<!--                    </a-col>-->

                    <a-col :span="4">
                        <a-form-item label="公司：">
                            <a-select v-model="param.compId" placeholder="请选择公司" @change="compChange" >
                                <a-select-option value="">全部</a-select-option>
                                <a-select-option :value="item.id" v-for="(item, index) in compList" :key="index" >
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>

                    <a-col :span="4">
                        <a-form-item label="订单编号：">
                            <a-input placeholder="请输入订单编号进行查询" v-model="param.travelCode" @pressEnter="getList(0)"/>
                        </a-form-item>
                    </a-col>

                    <a-col :span="4">
                        <a-form-item label="垛码：">
                            <a-input placeholder="请输入垛码进行查询" v-model="param.code" @pressEnter="getList(0)"/>
                        </a-form-item>
                    </a-col>

                    <a-col span="4">
                        <a-form-item label="日期：">
                            <a-range-picker
                                    show-time
                                    format="YYYY/MM/DD"
                                    :value="[this.moment(createValue[0], dateFormat),this.moment(createValue[1], dateFormat)]"
                                    @change="onDateChange"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6" :style="{ textAlign: 'right' }">
                        <a-button type="primary" html-type="submit">
                            查询
                        </a-button>
                    </a-col>
                </a-row>
            </a-form>
            <!-- 表格 -->
            <div class="table">
                <a-table
                        :columns="columns"
                        :dataSource="dataList"
                        :pagination="pagination"
                        :customRow="rowClick"
                        rowKey="id"
                        @change="TableChange"
                >
                    <template slot="serial" slot-scope="text, record, index">
                        <template>
                            {{ ((pagination.current - 1)*pagination.pageSize) + (index+1) }}
                        </template>
                    </template>
                    <a slot="name" slot-scope="text">{{ text }}</a>

                    <template slot="inClosedLoop" slot-scope="text, record, index">
                        <template>
                            {{text | trueFilter}}
                        </template>
                    </template>


                </a-table>

            </div>


            <div class="table" v-if="currentItem.id > 0">

                <a-row :gutter="24">

<!--                    //证件信息-->
<!--                    <a-col :span="4">-->
<!--                        <page-header-wrapper>-->
<!--                            <a-card :bordered="false">-->
<!--                                <viewer :viewerList="currentItem.viewerList"></viewer>-->
<!--                            </a-card>-->
<!--                        </page-header-wrapper>-->
<!--                    </a-col>-->
<!--                    登记信息-->
                    <a-col :span="24">
                        <a-card class="card" :title="'物流信息：' + currentItem.scanDate+' '+currentItem.no" :bordered="false">
                            <a-descriptions title="1、发货信息":column="4">
                                <a-descriptions-item label="发货公司">{{ currentItem.fromCompName }}</a-descriptions-item>
                                <a-descriptions-item label="发货人">{{ currentItem.fromUser }}</a-descriptions-item>
                                <a-descriptions-item label="电话">{{ currentItem.fromPhone }}</a-descriptions-item>
                                <a-descriptions-item label="发货时间">{{ currentItem.scanDate }}</a-descriptions-item>

<!--                                <a-descriptions-item label="收货公司">{{ currentItem.toCompName }}</a-descriptions-item>-->
<!--                                <a-descriptions-item label="收货人">{{ currentItem.toUser }}</a-descriptions-item>-->
<!--                                <a-descriptions-item label="电话">{{ currentItem.toPhone }}</a-descriptions-item>-->

                            </a-descriptions>
<!--                            <a-descriptions title="2、行程信息":column="2">-->
<!--                                <a-descriptions-item label="始发地">{{ currentItem.fromAreaName }}</a-descriptions-item>-->
<!--                                <a-descriptions-item label="具体地址">{{ currentItem.fromAddress }}</a-descriptions-item>-->
<!--                                <a-descriptions-item label="目的地">{{ currentItem.toAreaName }}</a-descriptions-item>-->
<!--                                <a-descriptions-item label="具体地址">{{ currentItem.toAddress }}</a-descriptions-item>-->
<!--                            </a-descriptions>-->
                        </a-card>
                    </a-col>


                </a-row>


                <a-row :gutter="24">
                <a-col :span="12">
                    <div class="table">
                        <a-table
                                :columns="columnsRelax"
                                :dataSource="dataListRelax"
                                :pagination="paginationRelax"
                                rowKey="id"
                                :customRow="wallClick"
                                @change="TableChangeRelax"
                        >
                            <template slot="serial" slot-scope="text, record, index">
                                <template>
                                    {{ ((paginationRelax.current - 1)*paginationRelax.pageSize) + (index+1) }}
                                </template>
                            </template>

                        </a-table>

                    </div>
                </a-col>
                    <a-col :span="12">
                        <div class="table">
                            <a-table
                                    :columns="columnsWallCode"
                                    :dataSource="dataListWallCode"
                                    :pagination="paginationWallCode"
                                    rowKey="id"
                                    @change="TableChangeWallCode"
                            >
                                <template slot="serial" slot-scope="text, record, index">
                                    <template>
                                        {{ ((paginationWallCode.current - 1)*paginationWallCode.pageSize) + (index+1) }}
                                    </template>
                                </template>

                            </a-table>

                        </div>
                    </a-col>
                </a-row>


            </div>

        </div>
    </div>
</template>
<script>

import {travelList} from '@/api/travel/travel'
import {formatTime,getMonthStr} from '@/utils/time'
import { getAreaTree } from '@/api/area/index'
import { compAreaList } from '@/api/comp/comp'
import { codeList } from '@/api/wall/code'

import { wallList } from '@/api/wall/wall'



import viewer from "@/components/Viewer/ViewerPreview";

import moment from 'moment'

const columns = [
    {
        title: "序号 ",
        dataIndex: "serial",
        key: "serial",
        scopedSlots: {customRender: 'serial'}
    },
    {
        title: "发货时间 ",
        dataIndex: "scanDate",
        key: "scanDate",
        scopedSlots: {customRender: 'scanDate'}
    },
    {
        title: "订单编号",
        dataIndex: "no",
        key: "no"
    },
    // {
    //     title: "目的地",
    //     dataIndex: "toCompName",
    //     key: "toCompName"
    // },
    // {
    //     title: "联系人 ",
    //     key: "toUser",
    //     dataIndex: "toUser",
    // },
    // {
    //     title: "联系电话",
    //     key: "toPhone",
    //     dataIndex: "toPhone"
    // },
    // {
    //     title: "车牌 ",
    //     key: "travelTruckInfo",
    //     dataIndex: "travelTruckInfo"
    // },
    // {
    //     title: "承运人",
    //     key: "travelUser",
    //     dataIndex: "travelUser"
    // }
];

const dataList = [];

const columnsRelax = [
    {
        title: "序号 ",
        dataIndex: "serial",
        key: "serial",
        scopedSlots: { customRender: 'serial' }
    },
    {
        title: "堆垛编号 ",
        dataIndex: "no",
        key: "no"
    },
];

const dataListRelax = [
];


const columnsWallCode = [
    {
        title: "序号 ",
        dataIndex: "serial",
        key: "serial",
        scopedSlots: { customRender: 'serial' }
    },
    {
        title: "堆垛编号 ",
        dataIndex: "code",
        key: "code"
    },
];

const dataListWallCode = [
];
export default {
    components: {viewer},
    data() {
        return {
            moment,
            dateFormat: "YYYY/MM/DD HH:mm:ss",
            pagination: {
                current: 1,
                pageNo: 1,
                pageSize: 100, // 默认每页显示数量
                showSizeChanger: true, // 显示可改变每页数量
                pageSizeOptions: ['100', '50', '30'], // 每页数量选项
                showTotal: total => `共有 ${total} 条`, // 显示总数
                //onChange: (page, pageSize) => this.changePage(page, pageSize), // 点击页码事件
                total: 0 // 总条数
            },
            paginationRelax: {
                current: 1,
                pageNo: 1,
                pageSize: 100, // 默认每页显示数量
                showSizeChanger: true, // 显示可改变每页数量
                pageSizeOptions: ['100', '50', '30'], // 每页数量选项
                showTotal: total => `共有 ${total} 条`, // 显示总数
                //onChange: (page, pageSize) => this.changePageRelax(page, pageSize), // 点击页码事件
                total: 0 // 总条数
            },
            paginationWallCode: {
                current: 1,
                pageNo: 1,
                pageSize: 100, // 默认每页显示数量
                showSizeChanger: true, // 显示可改变每页数量
                pageSizeOptions: ['100', '50', '30'], // 每页数量选项
                showTotal: total => `共有 ${total} 条`, // 显示总数
                //onChange: (page, pageSize) => this.changePageWallCode(page, pageSize), // 点击页码事件
                total: 0 // 总条数
            },

            form: this.$form.createForm(this, {
                name: "",
            }),


            optionAreas: [
                {
                    value: '1',
                    label: '北京市'
                }
            ],
            showSearch: {
                filter: (inputValue, path) => {
                    return path.some(option => {
                            // label搜索
                            return fullText(inputValue, option.label);
                        }
                    )
                },
                matchInputWidth: true
            },
            param: {
                size: 100,
                page: 1,
                areaId: 0,
                demoId: "",
                code: "",
                travelCode: "",
                startDate: undefined,
                endDate: undefined,
            },
            dataList,
            columns,
            currentItem:{},
            entourages:[],

            paramRelax:{
                size: 100,
                page: 1,
                startDate:null,
                endDate:null,
                travelId: null ,
            },
            columnsRelax,
            dataListRelax,


            paramWallCode:{
                size: 100,
                page: 1,
                startDate:null,
                endDate:null,
                wallId: null ,
            },
            columnsWallCode,
            dataListWallCode,

            id: 0,


            spinning: false,


            compList:[],
            createValue: [],
        };
    },
    computed: {},
    filters: {

        trueFilter (status) {
            if(status === 0)
                return "否"
            else if(status === 1)
                return "是"
            else
                return "否"
        },
        formatDate(status) {
            return formatTime(status, "{y}-{m}-{d}")
        },
        formatTime(status) {
            return formatTime(status, "{y}-{m}-{d} {h}:{i}:{s}")
        },
    },
    created() {
        //日期初始化
        var startDate = Date.now();
        var endDate = Date.now();
        this.param.startDate = getMonthStr(startDate, -1)
        this.param.endDate = formatTime(startDate, '{y}-{m}-{d} 23:59:59')
        this.createValue = [this.param.startDate, this.param.endDate]

        var userId = localStorage.getItem("userId")
        var areaId = localStorage.getItem("userAreaId")
        // 获取当前账号信息
        // this.param.areaId = areaId
        // 获取当前账号信息
        // this.areaId = areaId
        // 获取区划列表
        this.getAreaTree()
        this.getComp(this.areaId)
        this.getList(0);
    },
    updated() {
        console.log("updated");
    },
    methods: {

        /**
         * 点击表格行触发
         * @param {Object} record - 行数据
         * @param {Number} index - 索引值
         * @return Function
         */
        rowClick: function(record, index) {
            return {
                on: {

                    click: () => {

                        this.currentItem = record
                        if(typeof record.carInOutInfo != 'undefined' && record.carInOutInfo != null
                        && typeof record.carInOutInfo.entourages != 'undefined' && record.carInOutInfo.entourages != null
                        && record.carInOutInfo.entourages.length > 0)
                        {
                            this.entourages = record.carInOutInfo.entourages
                        }
                        else{
                            this.entourages = []
                        }
                        console.log('点击了我')

                        this.onQueryScan(record)
                    },

                    dblclick: () => {
                        console.log('双击了我')
                    },

                    // ...
                }
            }
        },

        wallClick: function(record, index) {
            return {
                on: {

                    click: () => {
                        //查询
                        this.onQueryCode(record)
                    },

                    dblclick: () => {
                        console.log('双击了我')
                    },

                    // ...
                }
            }
        },


        onQueryScan(record) {
            this.paramRelax.travelId = record.id

            this.getRelaxList(0);
        },

        getRelaxList(number) {

            if (number === 0) {
                this.paginationRelax.current = 1
                this.paramRelax.page = 1
            }

            var param = this.paramRelax

            wallList(param).then(response => {
                console.log(response.data)

                this.dataListRelax = response.data.list
                if (this.dataListRelax) {
                    this.paginationRelax.total = response.data.total
                }
            })
        },


        onQueryCode(record) {
            this.paramWallCode.wallId = record.id

            this.getWallCodeList(0);
        },

        getWallCodeList(number) {

            if (number === 0) {
                this.paginationWallCode.current = 1
                this.paramWallCode.page = 1
            }

            var param = this.paramWallCode

            codeList(param).then(response => {

                this.dataListWallCode = response.data.list
                if (this.dataListWallCode) {
                    this.paginationWallCode.total = response.data.total
                }
            })
        },

        compChange (value) {
            this.param.compId = value

            this.getList(0)
        },
        getComp (value) {
            compAreaList({
                page:1,
                size:100,
                areaId: value
            }).then(res => {
                this.compList = res.data.list

            });
        },

        areaChange (value) {
            this.param.areaId = value[value.length - 1]

            this.getComp(this.param.areaId)

            this.getList(0)
        },
        getAreaTree () {
            getAreaTree({areaId:this.areaId}).then(response => {
                this.optionAreas = response.data
            })
        },
        getList(number) {

            if (number === 0) {
                this.pagination.current = 1
                this.param.page = 1
            }

            var param = this.param

            travelList(param).then(response => {

                this.dataList = response.data.list
                if (this.dataList) {
                    this.pagination.total = response.data.total
                }
                for (let i = 0; i < this.dataList.length; i++) {
                    this.dataList[i].viewerList = []
                    this.dataList[i].viewerList.push({id: 1, url: this.dataList[i].carPng})
                    this.dataList[i].viewerList.push({id: 2, url: this.dataList[i].drivePng})

                }
            })
        },
        // 搜索
        handleSearch(e) {

            e.preventDefault();

            this.form.validateFields((error, values) => {
                console.log("error", error);
                console.log("Received values of form: ", values);
            });

            this.getList(0);
        },

        onDateChange(date, dateString) {
            console.log(date)
            console.log(dateString)
            this.createValue = date
            this.param.startDate = dateString[0]
            this.param.endDate = dateString[1]

            this.getList(0);
        },

        TableChange(e) {
            // 每页数量变更
            this.pagination.current = e.current
            this.param.page = e.current
            this.param.size = e.pageSize
            this.getList()
        },
        changePage(page, pageSize) {
            // 页码变更
            this.pagination.current = page
            this.param.page = page
            this.param.size = pageSize
            this.getList()
        },
        TableChangeRelax (e) {
            // 每页数量变更
            this.paginationRelax.current = e.current
            this.paramRelax.page = e.current
            this.paramRelax.size = e.pageSize
            this.getRelaxList()
        },
        changePageRelax (page, pageSize) {
            // 页码变更
            this.paginationRelax.current = page
            this.paramRelax.page = page
            this.paramRelax.size = pageSize
            this.getRelaxList()
        },


        TableChangeWallCode (e) {
            // 每页数量变更
            this.paginationRelax.current = e.current
            this.paramRelax.page = e.current
            this.paramRelax.size = e.pageSize
            this.getWallCodeList()
        },
        wallCodechangePage (page, pageSize) {
            // 页码变更
            this.paginationRelax.current = page
            this.paramRelax.page = page
            this.paramRelax.size = pageSize
            this.getRelaxList()
        },

    }
};
</script>
<style scoped>
    .ant-advanced-search-form {
        padding: 24px;
        background: #ffffff;
        /* border: 1px solid #d9d9d9; */
        /* border-radius: 6px; */
    }

    .ant-advanced-search-form .ant-form-item {
        display: flex;
    }

    .ant-advanced-search-form .ant-form-item-control-wrapper {
        flex: 1;
    }

    #components-form-demo-advanced-search .ant-form {
        max-width: none;
    }

    #components-form-demo-advanced-search .search-result-list {
        margin-top: 16px;
        border: 1px dashed #e9e9e9;
        border-radius: 6px;
        background-color: #ffffff;
        min-height: 200px;
        text-align: center;
        padding-top: 80px;
    }

    .table {
        margin-top: 20px;
        background: #ffffff;
        padding: 20px;

    }

    /deep/ .ant-table-tbody > tr > td {
        padding: 5px 5px !important;
    }

    .load {
        width: 100%;
        height: 100%;
        background-color: #000;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        opacity: 0.3;
        /*兼容IE8及以下版本浏览器*/
        filter: alpha(opacity=30);

        display: flex;
        align-items: center;
        justify-content: center;
    }

</style>
